import React, { useEffect, useState } from 'react'
import './Header.scss'
import { ReactComponent as Logo } from '../../assets/Logo-light.svg'
import { Link } from 'react-router-dom'

interface HeaderProps {
    
}

const Header:React.FC<HeaderProps> = ({}) => {
    const [ url, setUrl ] = useState<string>('')
    const [ active, setActive ] = useState(false)
    const [ opacity, setOpacity ] = useState(0)
 
    useEffect(()=>{
        let url = window.location.pathname
        console.log(url.slice(1));
        
        setUrl(url.slice(1))
    },[window.location.pathname])

    window.onscroll = (e) => {
        let header: any = document.getElementById('header') 
        header.classList.remove('home')
        setOpacity(window.scrollY/500)

        if(window.scrollY > 100) {
            header.classList.remove('home')
        } else {
            header.classList.add('home')
        }
    }

    const toggleMenu = () => {
        const menu = document.getElementById('menu')
        const header = document.getElementById('header')
        const root = document.getElementById('root')
        root?.classList.toggle('non-scroll')
        menu?.classList.toggle('menu-collapse')
        header?.classList.toggle('white-bg')
        setActive(!active)
    }

    

    const headerLinks = [
        {
            id: 1,
            url: 'services',
            title: 'Services'
        },
        {
            id: 2,
            url: 'portfolio',
            title: 'Portfolio'
        },
        {
            id: 3,
            url: 'about',
            title: 'About us'
        },
        {
            id: 4,
            url: 'contact',
            title: 'Contact us'
        },
    ]

    return (
        <header id='header' style={{backgroundColor: `rgba(255,255,255,${url === '/' ? opacity : '1'})`}} className={`Header ${url === '' && `home`}`}>
            <div className="container py-4 d-flex justify-content-between align-items-center">
                <a href="/">
                    <Logo className='logo' />
                </a>
                <div className="d-none d-md-flex links-container">
                    <div className="links-block">
                        {
                            headerLinks.map((link) => {
                                return  <Link key={link.id} to={link.url} className={ url === link.url ? 'active link' : 'link'}>{link.title}</Link>
                            })
                        }
                    </div>
                    <div className="language-switcher ms-5 d-flex ">
                        EN
                        <i className="fa-solid fa-chevron-down"></i>
                    </div>
                </div>

                <div className="mobile-bar-menu d-md-none" onClick={toggleMenu}>
                    {
                        active 
                        ? 
                        <i className="fa-solid fa-xmark"></i>
                        : 
                        <i className="fa-solid fa-bars"></i>
                    
                    }
                </div>

                <div id='menu' className="menu-collapse mobile-links-menu">
                    <Link to='/services' className="link">Services</Link>
                    <Link to='/portfolio' className="link">Portfolio</Link>
                    <Link to='/about' className="link">About Us</Link>
                    <Link to='/contact' className="link">Contact Us</Link>
                </div>


            </div> 
        </header>
    )
}

export default Header